import React, { Component } from 'react';
import BannerWithLinkProps from './BannerWithLink.props';
import BannerWithLinkState from './BannerWithLink.state';
import { GlobalContext } from '../../interfaces/GlobalContext/GlobalContext';

export default class BannerWithLink extends Component<BannerWithLinkProps, BannerWithLinkState> {
    static contextType = GlobalContext;
    context!: React.ContextType<typeof GlobalContext>;

    constructor(props: BannerWithLinkProps) {
        super(props);
        this.state = { 
            key: 'value',
            pageDetails: {
                campaignId: this.props.pageDetails?.campaignId,
                pageType: this.props.pageDetails?.pageType
            }
        };
    }

    bannerWrapperStyles = {
        padding: '45px',
        backgroundColor: '#ececec'
    }

    render(): React.ReactNode {
        return (
            <>
                <section className="banner-with-link content-section">
                    <div className="banner-with-link__wrapper">
                        <div className="banner-with-link__content search-cta-teaser__content">
                            <div className="container">
                                <div className="row">
                                    <div className="col-12">
                                        <h2>{this.context.i18nProvider.get('bannerWithLink.title')}</h2>
                                        <div className="call-to-action-tsr call-to-action-tsr--violet">
                                            <div className="row">
                                                <div className="col-12 col-md-7">
                                                    <span className="call-to-action-tsr__text" dangerouslySetInnerHTML={{ 
                                                        __html: (this.context.i18nProvider.get('bannerWithLink.teaserText') || '')
                                                    }}>
                                                    </span>
                                                </div>
                                                <div className="col-12 col-md-4 offset-md-1">
                                                    <div className="call-to-action-tsr__button" dangerouslySetInnerHTML={{
                                                        __html:
                                                            (this.context.i18nProvider.get(
                                                                'bannerWithLink.buttons',
                                                                { returnObjects: true }
                                                            ) as unknown as Array<string>).join()
                                                    }}>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="banner-with-link__text" dangerouslySetInnerHTML={{ 
                                            __html: (this.context.i18nProvider.get('bannerWithLink.text') || '')
                                        }}>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        );
    }
}
